<script setup>
import { ref, computed, watch } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import ButtonV4 from 'dashboard/components-next/button/Button.vue';
import ConvertToTicketModal from './ConvertToTicketModal.vue';
import TicketBadge from './TicketBadge.vue';

const props = defineProps({
  conversationId: { type: [Number, String], required: true },
});

const store = useStore();
const isFeatureEnabled = useMapGetter('accounts/isFeatureEnabledonAccount');
const accountId = useMapGetter('getCurrentAccountId');

const showModal = ref(false);
const ticketEnabled = computed(() =>
  isFeatureEnabled.value(accountId.value, FEATURE_FLAGS.TICKET_MANAGEMENT)
);

const ticket = computed(() =>
  store.getters['tickets/getTicketByConversationId'](Number(props.conversationId))
);

watch(
  () => props.conversationId,
  async id => {
    if (!ticketEnabled.value || !id) return;
    await store.dispatch('tickets/fetchTicketByConversation', id);
  },
  { immediate: true }
);
</script>

<template>
  <div v-if="ticketEnabled" class="flex items-center">
    <TicketBadge
      v-if="ticket"
      :conversation-id="conversationId"
      @open-panel="() => {}"
    />
    <ButtonV4
      v-else
      size="sm"
      variant="outline"
      :label="$t('TICKETING.HEADER.CONVERT_TO_TICKET')"
      @click="showModal = true"
    />
    <ConvertToTicketModal
      v-model:show="showModal"
      :conversation-id="conversationId"
      @converted="store.dispatch('tickets/fetchTicketByConversation', conversationId)"
    />
  </div>
</template>
